export enum EditorLoader {
  Default = 0,
  isBuilding = 1,
  isLoaded = 2,
  hasError = 3,
}
